import React, { ReactElement } from 'react';
import * as moment from 'moment';
import { Activity } from './Activity';

export type Section = {
  date: moment.Moment;
  activities: Activity[];
};

type ActivityFeedSectionProps = {
  section: Section;
  isReversed: boolean;
};

export const ActivityFeedSection = (props: ActivityFeedSectionProps): ReactElement => {
  const { section } = props;
  return (
    <div className="section">
      <div className="section-title">{section.date.format('dddd MMMM Do')}</div>
      {section.activities
        .sort((a, b) => {
          if (props.isReversed) {
            if (a.date.diff(b.date)) return a.date.diff(b.date);
            if (b.order < a.order) return 1;
            if (b.order > a.order) return -1;
            return 0;
          }
          if (b.date.diff(a.date)) return b.date.diff(a.date);
          if (a.order < b.order) return 1;
          if (a.order > b.order) return -1;
          return 0;
        })
        .map((activity) => activity.render())}
    </div>
  );
};
